export enum ItemOrigin {
    Development = 1,
    Declination = 2,
}
